jQuery(document).ready(function($) {
  'use strict';

  var loaded;

  function registerImpression() {
    // add forEach when missing on NodeList for IE11
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = Array.prototype.forEach;
    }

    let personalizationItems = new Array();

    document.querySelectorAll('[data-personalization-data]').forEach(function(item) {
      var personalizationData = item.getAttribute('data-personalization-data');

      if (!personalizationItems.includes(personalizationData)) {
        personalizationItems.push(personalizationData);

        // Register impression
        if (typeof ipcsaclick !== 'undefined') {
          window.ipcsaclick({id: personalizationData,
                            type: 'nba-impression'});
        }
      }
    });
  }

  if (document.querySelectorAll('[data-personalization-data]').length > 0) {
    loaded = setInterval(function() {
      if (typeof ipcsaclick !== 'undefined' && (/loaded|complete/).test(document.readyState)) {
        clearInterval(loaded);
        registerImpression();
      }
    }, 1000);
  }
});
